import React from "react";
import { IconButton, IconButtonProps, useTheme } from "@mui/material";
import styled from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import Loader from "components/other/Loader";

const StyledControlButton = styled(IconButton)`
  && {
    background-color: ${({ theme }) => theme.duo.palette.blueMain};
    color: white;
    width: 70px;
    height: 70px;
    border-radius: 50%;
  }
  &&:hover,
  &&:focus-visible,
  &&.Mui-focusVisible,
  &&:active {
    background-color: ${({ theme }) => theme.duo.palette.blueMain};
    box-shadow: none;
  }
  &&:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const NoSelectArea = styled.div`
  user-select: none; // fix selection on iphone when long press on control button
`;

const Icon = styled(FontAwesomeIcon)`
  font-size: 24px;
`;

export type ControlButtonProps = Omit<IconButtonProps, "children"> & {
  icon: IconDefinition;
  showLabel?: boolean;
  loading?: boolean;
};

export const ControlButton: React.FC<ControlButtonProps> = ({ icon, loading, ...buttonProps }) => {
  const theme = useTheme();

  return (
    <NoSelectArea>
      <StyledControlButton {...buttonProps}>
        {loading ? <Loader size={24} color={theme.duo.palette.white} /> : <Icon icon={icon} />}
      </StyledControlButton>
    </NoSelectArea>
  );
};
